import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { colors } from '../../styles/tokens';

export const Container = styled.header<{ scrolled: boolean }>`
  position: sticky;
  top: 0;
  z-index: 50;

  width: 100%;
  background: ${props =>
    props.scrolled ? 'rgba(18, 18, 18, 0.5)' : 'rgba(18, 18, 18, 0.86)'};
  backdrop-filter: blur(16px);
  border-bottom: 1px solid
    ${props => (props.scrolled ? 'rgba(42, 42, 42, 0.5)' : colors.borderSubtle)};
  transition: background 0.35s ease, border-color 0.35s ease;

  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1720px;

  padding: 16px clamp(20px, 5vw, 96px);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const LogoImage = styled.img`
  width: 30px;
  height: 30px;
`;

export const LogoText = styled.span`
  font-weight: 800;
  font-size: 19px;
  letter-spacing: -0.02em;
  color: ${colors.textPrimary};
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 28px;

  font-size: 15px;
  font-weight: 600;
  color: ${colors.textSecondary};
  flex-wrap: wrap;
  justify-content: flex-end;

  a {
    color: ${colors.textSecondary};
    transition: color 0.2s;

    &:hover {
      color: ${colors.textPrimary};
    }
  }

  @media (max-width: 900px) {
    display: none;
  }
`;
